import { render, staticRenderFns } from "./myHeader.vue?vue&type=template&id=c37b49aa&scoped=true"
import script from "./myHeader.vue?vue&type=script&lang=js"
export * from "./myHeader.vue?vue&type=script&lang=js"
import style0 from "./myHeader.vue?vue&type=style&index=0&id=c37b49aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37b49aa",
  null
  
)

export default component.exports